import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ICompany } from '@bca-shared/models/company';
import { ISuggestion } from '@bca-shared/modules/type-ahead/type-ahead.models';
import { Observable } from 'rxjs';

@Component({
  selector: 'bca-company-search',
  templateUrl: 'company-search.component.html',
  styleUrls: ['company-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanySearchComponent implements OnInit {
  @Input()
  selectedCompany: ICompany;

  @Input()
  companyLoading: boolean;

  @Input()
  companyFetching: boolean;

  @Input()
  companyRequiredError: string | undefined;

  @Input()
  searchFn: (searchTerm$: Observable<string>) => Observable<ISuggestion<ICompany>[]>;

  @Output()
  focus = new EventEmitter<void>();

  @Output()
  focusout = new EventEmitter<void>();

  @Output()
  close = new EventEmitter<void>();

  @Output()
  selected = new EventEmitter<ICompany>();

  searchControl = new FormControl(null, Validators.required);

  ngOnInit(): void {
    const { searchControl, selectedCompany } = this;
    if (selectedCompany) {
      const { searchTerm } = selectedCompany;
      searchControl.setValue(searchTerm, { emitEvent: false });
    }
  }

  onFocus(): void {
    const { searchControl, focus } = this;
    searchControl.reset();
    focus.emit();
  }

  onFocusOut(): void {
    const { searchControl, focusout, selectedCompany } = this;

    if (selectedCompany) {
      const { searchTerm } = selectedCompany;
      searchControl.setValue(searchTerm, { emitEvent: false });
    }
    focusout.emit();
  }

  onSelectedCompany(companySelection: ISuggestion<ICompany>): void {
    const { selected } = this;
    const { subject, displayText } = companySelection;
    const company = { ...subject, searchTerm: displayText };
    selected.emit(company);
  }

  closeCompany(): void {
    const { searchControl, close } = this;
    searchControl.reset();
    close.emit();
  }
}
